export default __webpack_public_path__ + "static/media/g2021-1.f9bb044f.jpeg";